import Layout from '@/layout'
export default [
    {
        path: '/',
        component: Layout,
        redirect: '/company-management',
        children: [{
            path: '/company-management',
            name: 'CompanyManagement',
            component: () => import('@/views/company-management/index'),
            adminOnly: true,
            meta: { title: 'Company Management', icon: 'example', adminRequire: true }
        }],
    },
    {
        path: '/company-management/:id',
        component: Layout,
        children: [{
            path: '/company-management/:id',
            name: 'CompanyDetail',
            component: () => import('@/views/company-management/detail'),
            meta: { adminRequire: true },
            hidden: true
        }]
    },
]